'use client';

import Lottie from "lottie-react";

import cookingLoading from "@/assets/lotties/cooking_loader.json";
import styles from "@/app/page.module.scss";

export default function PreloaderComponent() {
  return (
    <div className={styles.preloader}>
      <Lottie animationData={cookingLoading} loop={true} className={styles.lottie} />
    </div>
  );
}
